import { render } from "./BakersNavigation.vue?vue&type=template&id=16162ce6"
import script from "./BakersNavigation.vue?vue&type=script&lang=js"
export * from "./BakersNavigation.vue?vue&type=script&lang=js"

import "./BakersNavigation.vue?vue&type=style&index=0&id=16162ce6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__